<template>
    <v-card id="user-detail-statics-card">
        <v-card-title class="card-title">
            {{ datatext }}
        </v-card-title>
        <span v-if="!this.$store.state.monthlyDetail.detailLoading">{{ data }}</span>
        <span class="loading" v-else> <v-icon>sync</v-icon>  Szinkronizálás </span>
    </v-card>
</template>

<script>
    export default {
        name: "UserDetailStaticsCard",

        props: {
            data: {
                required: true
            },
            datatext: {
                required: true
            }
        }
    }
</script>

<style lang="scss">
    #user-detail-statics-card {
        .card-title { font-weight: 300; font-size: 14px; padding-top:5px; padding-bottom: 0px; margin-bottom: -7px}
        span { padding-left: 16px; font-size: 22px; font-weight: 600; }
        padding-bottom: 14px; padding-top: 3px; background: #34495e; color: #efefef;
        .loading i { color: #efefef; -webkit-animation: rotating 2s linear infinite; }
    }
</style>
